'use client';

import { GalleryComp } from 'components';
import { GlobalContext } from 'context';
import { useContext, useState } from 'react';
import { AttachmentType } from 'types';
import { __BrandSections } from './brandDetail.data';
import styles from './brandDetail.module.scss';
import { __InitFilterBrand } from './brandDetail.scripts';
import { __BrandDetailPropsType, __BrandSectionEnum } from './brandDetail.type';
import BrandInfoComp from './brandInfo/brandInfo.index';
import BrandHiringComp from './hiring/hiring.index';
import BrandRankingComp from './ranking/ranking.index';
import BrandServiceListComp from './serviceList/serviceList.index';
function BrandDetailComp(props: __BrandDetailPropsType) {
  const langText = useContext(GlobalContext).langText;
  const lang = langText.brandDetail;
  const [filters, setFilters] = useState(__InitFilterBrand(props.initialFilters));
  const images: AttachmentType[] | undefined = props.data.gallery?.filter((image): image is AttachmentType => !!image);
  return <div className={`pb-4 ${styles['brand-detail-layout']}`} data-sentry-component="BrandDetailComp" data-sentry-source-file="brandDetail.index.tsx">
            {/* brand info */}
            <div className={`${styles['info-slider']} d-flex main-content`}>
                <BrandInfoComp data={props.data} data-sentry-element="BrandInfoComp" data-sentry-source-file="brandDetail.index.tsx" />
                {props.data.gallery?.length !== 0 && <div className={`${styles['slider']}`}>
                        <GalleryComp data={images} className={`${styles['slider-brand']} h-100`} title={props.data.title} />
                    </div>}
            </div>
            <div className={`${styles['fixed-section']} mb-8`}>
                <div className={`main-content gap-12 align-items-center h-100 ${styles['border']}`}>
                    {__BrandSections(lang).map(item => <div key={item.slug} className={`center-content ph-2 ${styles['btn']} ${filters.section === item.slug ? styles['active'] : ''}`} onClick={() => setFilters({
          section: item.slug
        })}>
                            <item.icon size={22} />
                            <span className={filters.section === item.slug ? '' : 'd-pre-md-none'}>{item.title}</span>
                        </div>)}
                </div>
            </div>
            {filters.section === undefined || filters.section === __BrandSectionEnum.services ? <BrandServiceListComp data={props.data} initialFilters={props.initialFilters} categories={props.categories} services={props.services} filters={filters} setFilters={setFilters} /> : filters.section === __BrandSectionEnum.ranking ? <BrandRankingComp data={props.data} ranking={props.rankings} filters={filters} setFilters={setFilters} initialFilters={props.initialFilters} /> : filters.section === __BrandSectionEnum.hiring ? <BrandHiringComp data={props.data} hiring={props.hiring} filters={filters} setFilters={setFilters} initialFilters={props.initialFilters} categories={props.hiringCategories} /> : null}
        </div>;
}
export default BrandDetailComp;